<p-dialog [visible]="visible" (visibleChange)="!$event && close()" [modal]="true"
  [header]="'Help with ' + pageTitle" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(1120px, 96vw)' }" [breakpoints]="{ '860px': '96vw' }"
  styleClass="page-help-dialog">
  <div class="page-help-layout">
    <aside class="page-help-summary">
      <div class="page-help-summary-icon"><i class="pi pi-question-circle" aria-hidden="true"></i></div>
      <div>
        <small>PAGE GUIDE</small>
        <h2>{{ pageTitle }}</h2>
        <p>Use this guide while you complete the page. Your entries stay in place when you close Help.</p>
      </div>
      @if (checklist.length) {
        <div class="page-help-checklist">
          <h3>Quick start</h3>
          <ol>
            @for (step of checklist; track step) {
              <li>{{ step }}</li>
            }
          </ol>
        </div>
      }
    </aside>

    <section class="page-help-card" aria-label="Page help content">
      @if (manualId || videoUrl) {
        <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)">
          <p-tablist>
            @if (manualId) { <p-tab value="guide">Written guide</p-tab> }
            @if (videoUrl) { <p-tab value="video">Video</p-tab> }
          </p-tablist>
        </p-tabs>
      }

      @if (activeTab === 'video' && visible && videoUrl) {
        <div class="page-help-video">
          <iframe [src]="videoUrl" [title]="pageTitle + ' video guide'" loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      } @else if (manualId) {
        @if (loading) {
          <div class="page-help-state" role="status"><i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Loading guide...</div>
        } @else if (error) {
          <div class="page-help-state" role="alert">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            The guide is unavailable. Try opening the full guide or return later.
          </div>
        } @else if (guide) {
          <div class="page-help-guide" [innerHTML]="guide.renderedHtml" (click)="openGuideLink($event)"></div>
        }
      }
    </section>
  </div>

  <ng-template pTemplate="footer">
    <div class="page-help-footer">
      @if (manualId) {
        <a class="page-help-full-link" [href]="'/help/' + manualId" target="_blank" rel="noopener noreferrer">
          <i class="pi pi-external-link" aria-hidden="true"></i> Open full guide
        </a>
      }
      <span class="page-help-footer-spacer"></span>
      <p-button label="Close" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="close()"></p-button>
    </div>
  </ng-template>
</p-dialog>
